// Third-party
import React, { Component } from 'react';
import { withFormik, FormikProps, Form } from 'formik';
import * as Yup from 'yup';

// Components
import FormInput from './FormInput';
import { PrimaryButton, SecondaryButton } from '../buttons';

// Utils
import { formatMessage, FormattedMessage } from '../../../utils/i18n';
import notification from '../../../utils/notification';
import EnterpriseGroup from '@/types/enterprise-group';

interface ParentProps {
  onAddGroup: (name: string) => Promise<EnterpriseGroup>;
  onCancel: () => void;
}

interface FormProps {
  name: string;
}

type Props = ParentProps & FormikProps<FormProps>;

class AddEnterpriseGroupForm extends Component<Props> {
  static defaultProps = {
    onCancel: () => {},
  };

  canSubmit = () => {
    const { values, initialValues, isSubmitting, errors } = this.props;
    const isDirty = values !== initialValues;
    const hasErrors = Object.keys(errors).length > 0;
    return !hasErrors && isDirty && !isSubmitting;
  };

  render() {
    return (
      <div className="settings-enterprise-add-group section align-items-center">
        <Form>
          <div className="d-flex justify-content-between">
            <FormInput required name="name" placeholder="HQ" label={formatMessage('Admin.Enterprise.Fields.GroupName')} />
          </div>
          <p>
            <FormattedMessage id="Admin.Enterprise.AddGroupInfo" />
          </p>

          <div className="form-actions d-flex justify-content-end">
            <SecondaryButton onClick={this.props.onCancel}>
              <FormattedMessage id="Common.Cancel" />
            </SecondaryButton>

            <PrimaryButton type="submit" disabled={!this.canSubmit()}>
              <FormattedMessage id="Admin.Enterprise.AddGroupBtn" />
            </PrimaryButton>
          </div>
        </Form>
      </div>
    );
  }
}

const EnterpriseGroupSchema = Yup.object().shape({
  name: Yup.string().min(1).max(50).required(),
});

const formikWrapper = withFormik<Props, FormProps>({
  validationSchema: EnterpriseGroupSchema,
  handleSubmit: (values, { props, setSubmitting, resetForm }) => {
    props.onCancel();
    props
      .onAddGroup(values.name)
      .then(() => {
        notification.success(formatMessage('Admin.Enterprise.AddGroupSuccess'));
        resetForm();
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
});

export default formikWrapper(AddEnterpriseGroupForm) as any;
